import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const editBranchThreePl = async (branch_id: string, partner_id: string): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;
    const uri = `${config.uri.base_url}/branches/${branch_id}/edit/three-pl`;

    const options = {
      method: 'POST',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      }),
      body: JSON.stringify({ partner_id: partner_id })
    };

    const response = await fetch(uri, options);

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return response;
  } catch (err) {
    throw err;
  }
};
